import styled from 'styled-components';

export const DrawerBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: var(--shadow-a35);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
`;

export const Drawer = styled.div`
  width: min(560px, 100%);
  height: 100vh;
  background: var(--color-surface);
  box-shadow: -8px 0 24px var(--shadow-a15);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 18px;
  gap: 14px;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  border-bottom: 1px solid var(--shadow-a08);
  padding-bottom: 10px;
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  font-family: var(--font-heading, sans-serif);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--green-800);
  letter-spacing: 0.02em;
  flex: 1;
  min-width: 0;
  word-break: break-word;
`;

export const SectionCard = styled.div`
  background: var(--white-a55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border: 1px solid var(--green-a08);
  border-radius: 12px;
  padding: 12px 14px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 10px 0;
  font-family: var(--font-heading, sans-serif);
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.10em;
  color: var(--orange-500);
  font-weight: 700;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const FieldLabel = styled.label`
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--ink-a70);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const FieldValue = styled.div`
  font-family: var(--font-body);
  color: var(--black);
  font-size: 0.92rem;
  min-height: 1.4em;
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 14px;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const InlineTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;

  th, td {
    text-align: left;
    padding: 6px 8px;
    border-bottom: 1px solid var(--shadow-a08);
  }
  th {
    color: var(--ink-a70);
    font-weight: 700;
    font-size: 0.70rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
  td:last-child, th:last-child { text-align: right; }
`;

export const NegativeValue = styled.span`
  color: var(--red-600);
  font-weight: 600;
`;

export const InlineAddRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px auto;
  gap: 8px;
  margin-top: 12px;
  align-items: end;
`;

export const EmptyHint = styled.div`
  font-size: 0.85rem;
  color: var(--ink-a60);
  padding: 6px 2px;
`;
